import { EVENTS } from "./constants";
import { ActiveVehicle } from "./types";

type Vehicle = NonNullable<ActiveVehicle>["vehicle"];
type VehicleField = "make" | "model" | "year" | "series" | "variant";

const FIELD_ORDER: VehicleField[] = [
  "make",
  "model",
  "year",
  "series",
  "variant",
];

function getFieldValue(vehicle: Vehicle, field: VehicleField): string {
  if (field === "year") {
    return window.vehicleManager.vehicles.formatYearRange(
      vehicle.yearFrom,
      vehicle.yearTo,
    );
  }
  return vehicle[field];
}

function applyLabel(el: HTMLElement, data: ActiveVehicle) {
  if (data) {
    el.textContent = FIELD_ORDER.filter((field) =>
      el.hasAttribute(`data-active-vehicle-label-${field}`),
    )
      .map((field) => getFieldValue(data.vehicle, field))
      .join(" ")
      .trim();
  } else {
    const defaultText = el.dataset.activeVehicleLabelDefault ?? "";
    el.textContent = defaultText;
  }
}

let activeVehicle: ActiveVehicle = null;

function updateActiveVehicleLabels(root: ParentNode = document) {
  root
    .querySelectorAll<HTMLElement>("[data-active-vehicle-label]")
    .forEach((el) => applyLabel(el, activeVehicle));
}

window.vehicleManager.pubsub.subscribe(
  EVENTS.vehicleChange,
  (data: ActiveVehicle) => {
    activeVehicle = data;
    updateActiveVehicleLabels();
  },
  { replayLast: true },
);

// Section re-renders (theme editor) reset labels to their server-rendered
// default text, since the fresh markup carries no knowledge of the active
// vehicle — reapply it to just the section that reloaded.
document.addEventListener("shopify:section:load", (event) => {
  if (event.target instanceof HTMLElement) {
    updateActiveVehicleLabels(event.target);
  }
});
